// extracted by mini-css-extract-plugin
export default {"container":"ChekPushNotification_container__Kw3vM","content":"ChekPushNotification_content__7eryh"};